/**
* Theme: Hyper - Responsive Bootstrap 5 Admin Dashboard
* Author: Coderthemes
* Module/App: Layout Js
*/

import jQuery from 'jquery';
import { Popover, Tooltip, Offcanvas, Toast } from 'bootstrap';
import { createIcons, icons } from 'lucide';
import moment from 'moment';

const $ = jQuery;

// Bootstrap Components
function initComponents() {

    //loader - Preloader
    $(window).on('load', function () {
        $('#status').fadeOut();
        $('#preloader').delay(350).fadeOut('slow');
    });

    // lucide Icons
    createIcons({ icons });

    // Popovers
    Array.from(document.querySelectorAll('[data-bs-toggle="popover"]')).map(popoverTriggerEl => new Popover(popoverTriggerEl))

    // Tooltips
    Array.from(document.querySelectorAll('[data-bs-toggle="tooltip"]')).map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl))

    // offcanvas
    Array.from(document.querySelectorAll('.offcanvas')).map(offcanvasEl => new Offcanvas(offcanvasEl))

    //Toasts
    let toastPlacement = document.getElementById("toastPlacement");
    if (toastPlacement) {
        document.getElementById("selectToastPlacement").addEventListener("change", function () {
            if (!toastPlacement.dataset.originalClass) {
                toastPlacement.dataset.originalClass = toastPlacement.className;
            }
            toastPlacement.className = toastPlacement.dataset.originalClass + " " + this.value;
        });
    }

    var toastElList = [].slice.call(document.querySelectorAll('.toast'))
    toastElList.map(function (toastEl) {
        return new Toast(toastEl)
    })

    // Bootstrap Alert Live Example
    const alertPlaceholder = document.getElementById('liveAlertPlaceholder')
    if (alertPlaceholder) {
        (message, type) => {
            const wrapper = document.createElement('div')
            wrapper.innerHTML = [
                `<div class="alert alert-${type} alert-dismissible" role="alert">`,
                `   <div>${message}</div>`,
                '   <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>',
                '</div>'
            ].join('')

            alertPlaceholder.append(wrapper)
        }
    }

    const alertTrigger = document.getElementById('liveAlertBtn')
    if (alertTrigger) {
        alertTrigger.addEventListener('click', () => {
            alert('Nice, you triggered this alert message!', 'success')
        })
    }

    // RTL Layout
    // if (document.getElementById('app-style').href.includes('rtl.min.css')) {
    //     document.getElementsByTagName('html')[0].dir = "rtl";
    // }
}

// Topbar Search Form
// function initSearch() {
//     // Search Toggle
//     var navDropdowns = $('.navbar-custom .dropdown:not(.app-search)');

//     // hide on other click
//     $(document).on('click', function (e) {
//         if (e.target.id == "top-search" || e.target.closest('#search-dropdown')) {
//             $('#search-dropdown').addClass('d-block');
//         } else {
//             $('#search-dropdown').removeClass('d-block');
//         }
//         return true;
//     });

//     // Search Toggle
//     $('#top-search').on('focus', function (e) {
//         e.preventDefault();
//         navDropdowns.children('.dropdown-menu.show').removeClass('show');
//         $('#search-dropdown').addClass('d-block');
//         return false;
//     });

//     // hide search on opening other dropdown
//     navDropdowns.on('show.bs.dropdown', function () {
//         $('#search-dropdown').removeClass('d-block');
//     });
// }

// Topbar Fullscreen Button
function initfullScreenListener() {
    var fullScreenBtn = document.querySelector('[data-toggle="fullscreen"]');

    if (fullScreenBtn) {
        fullScreenBtn.addEventListener('click', function (e) {
            e.preventDefault();
            document.body.classList.toggle('fullscreen-enable')
            if (!document.fullscreenElement && /* alternative standard method */ !document.mozFullScreenElement && !document.webkitFullscreenElement) {  // current working methods
                if (document.documentElement.requestFullscreen) {
                    document.documentElement.requestFullscreen();
                } else if (document.documentElement.mozRequestFullScreen) {
                    document.documentElement.mozRequestFullScreen();
                } else if (document.documentElement.webkitRequestFullscreen) {
                    document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
                }
            } else {
                if (document.cancelFullScreen) {
                    document.cancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                }
            }
        });
    }
}

// Show/Hide Password
function initShowHidePassword() {
    $("[data-password]").on('click', function () {
        if ($(this).attr('data-password') == "false") {
            $(this).siblings("input").attr("type", "text");
            $(this).attr('data-password', 'true');
            $(this).addClass("show-password");
        } else {
            $(this).siblings("input").attr("type", "password");
            $(this).attr('data-password', 'false');
            $(this).removeClass("show-password");
        }
    });
}

// Form Validation
function initFormValidation() {
    // Example starter JavaScript for disabling form submissions if there are invalid fields
    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    // Loop over them and prevent submission
    document.querySelectorAll('.needs-validation').forEach(form => {
        form.addEventListener('submit', event => {
            if (!form.checkValidity()) {
                event.preventDefault()
                event.stopPropagation()
            }

            form.classList.add('was-validated')
        }, false)
    })
}

// Form Advance
function initFormAdvance() {
    // Select2
    if (jQuery().select2) {
        $('[data-toggle="select2"]').select2();
    }

    // Input Mask
    if (jQuery().mask) {
        $('[data-toggle="input-mask"]').each(function (idx, obj) {
            var maskFormat = $(obj).data("maskFormat");
            var reverse = $(obj).data("reverse");
            if (reverse != null)
                $(obj).mask(maskFormat, { 'reverse': reverse });
            else
                $(obj).mask(maskFormat);
        });
    }

    // Date-Range-Picker
    if (jQuery().daterangepicker) {
        //date pickers ranges only
        var start = moment().subtract(29, 'days');
        var end = moment();
        var defaultRangeOptions = {
            startDate: start,
            endDate: end,
            ranges: {
                'Today': [moment(), moment()],
                'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                'This Month': [moment().startOf('month'), moment().endOf('month')],
                'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
            }
        };

        $('[data-toggle="date-picker-range"]').each(function (idx, obj) {
            var objOptions = $.extend({}, defaultRangeOptions, $(obj).data());
            var target = objOptions["targetDisplay"];
            //rendering
            $(obj).daterangepicker(objOptions, function (start, end) {
                if (target)
                    $(target).html(start.format('MMMM D, YYYY') + ' - ' + end.format('MMMM D, YYYY'));
            });
        });

        // Datetime and date range picker
        let defaultOptions = {
            "cancelClass": "btn-light",
            "applyButtonClasses": "btn-success"
        };

        $('[data-toggle="date-picker"]').each(function (idx, obj) {
            var objOptions = $.extend({}, defaultOptions, $(obj).data());
            $(obj).daterangepicker(objOptions);
        });
    }

    // Bootstrap Timepicker
    if (jQuery().timepicker) {
        let defaultOptions = {
            "showSeconds": true,
            "icons": {
                "up": "mdi mdi-chevron-up",
                "down": "mdi mdi-chevron-down"
            }
        };

        $('[data-toggle="timepicker"]').each(function (idx, obj) {
            var objOptions = $.extend({}, defaultOptions, $(obj).data());
            $(obj).timepicker(objOptions);
        });
    }

    // Bootstrap Touchspin
    if (jQuery().TouchSpin) {
        let defaultOptions = {

        };

        $('[data-toggle="touchspin"]').each(function (idx, obj) {
            var objOptions = $.extend({}, defaultOptions, $(obj).data());
            $(obj).TouchSpin(objOptions);
        });
    }

    // Bootstrap Maxlength
    if (jQuery().maxlength) {
        var defaultOptions = {
            warningClass: "badge bg-success",
            limitReachedClass: "badge bg-danger",
            separator: ' out of ',
            preText: 'You typed ',
            postText: ' chars available.',
            placement: 'bottom',
        };

        $('[data-toggle="maxlength"]').each(function (idx, obj) {
            var objOptions = $.extend({}, defaultOptions, $(obj).data());
            $(obj).maxlength(objOptions);
        });
    }
}

export default class ThemeCustomizer {

    constructor() {
        this.html = document.getElementsByTagName('html')[0]
        this.config = {};
        this.defaultConfig = window.config;
    }

    initConfig() {

        let config = {};

        let t = sessionStorage.getItem("__HYPER_CONFIG__");
        let e = document.getElementsByTagName("html")[0]
        let i = { theme: "light", nav: "vertical", layout: { mode: "fluid", position: "fixed" }, topbar: { color: "light" }, menu: { color: "dark" }, sidenav: { size: "default", user: !1 } }
        let o = (this.html = document.getElementsByTagName("html")[0], config = Object.assign(JSON.parse(JSON.stringify(i)), {}), this.html.getAttribute("data-bs-theme"));
        o = (config.theme = null !== o ? o : i.theme, this.html.getAttribute("data-layout"));
        o = (config.nav = null !== o ? "topnav" === o ? "horizontal" : "vertical" : i.nav, this.html.getAttribute("data-layout-mode"));
        config.layout = {};
        o = (config.layout.mode = null !== o ? o : i.layout.mode, this.html.getAttribute("data-layout-position"));
        o = (config.layout.position = null !== o ? o : i.layout.position, this.html.getAttribute("data-topbar-color"));
        o = (config.topbar.color = null != o ? o : i.topbar.color, this.html.getAttribute("data-sidenav-size"));
        o = (config.sidenav.size = null !== o ? o : i.sidenav.size, this.html.getAttribute("data-sidenav-user"));
        o = (config.sidenav.user = null !== o || i.sidenav.user, this.html.getAttribute("data-menu-color"));
        config.menu.color = (null !== o ? o : i.menu.color);

        window.defaultConfig = JSON.parse(JSON.stringify(config));
        null !== t && (config = JSON.parse(t));
        if (!config.layout) {
            config.layout = {};
        }
        if (!config.menu) {
            config.menu = {};
        }
        if (!config.topbar) {
            config.topbar = {};
        }
        if (!config.sidenav) {
            config.sidenav = {};
        }
        window.config = config;
        "topnav" === e.getAttribute("data-layout") ? config.nav = "horizontal" : config.nav = "vertical";
        config && (e.setAttribute("data-bs-theme", config.theme), e.setAttribute("data-layout-mode", config.layout.mode));
        e.setAttribute("data-menu-color", config.menu.color);
        e.setAttribute("data-topbar-color", config.topbar.color);
        e.setAttribute("data-layout-position", config.layout.position);

        if ("vertical" == config.nav) {
            let t = config.sidenav.size;
            window.innerWidth <= 767 ? t = "full" : 767 <= window.innerWidth && window.innerWidth <= 1140 && "full" !== config.sidenav.size && "fullscreen" !== config.sidenav.size && (t = "condensed");
            e.setAttribute("data-sidenav-size", t);
            config.sidenav.user && "true" === config.sidenav.user.toString() ? e.setAttribute("data-sidenav-user", !0) : e.removeAttribute("data-sidenav-user");
        }

        this.defaultConfig = JSON.parse(JSON.stringify(config));
        this.config = JSON.parse(JSON.stringify(config));
        this.setSwitchFromConfig();
    }

    changeMenuColor(color) {
        this.config.menu.color = color;
        this.html.setAttribute('data-menu-color', color);
        this.setSwitchFromConfig();
    }

    changeLeftbarSize(size, save = true) {
        this.html.setAttribute('data-sidenav-size', size);
        if (save) {
            this.config.sidenav.size = size;
            this.setSwitchFromConfig();
        }
    }

    changeLayoutMode(mode, save = true) {
        this.html.setAttribute('data-layout-mode', mode);
        if (save) {
            this.config.layout.mode = mode;
            this.setSwitchFromConfig();
        }
    }

    changeLayoutPosition(position) {
        this.config.layout.position = position;
        this.html.setAttribute('data-layout-position', position);
        this.setSwitchFromConfig();
    }

    changeLayoutColor(color) {
        this.config.theme = color;
        this.html.setAttribute('data-bs-theme', color);
        this.setSwitchFromConfig();
    }

    changeTopbarColor(color) {
        this.config.topbar.color = color;
        this.html.setAttribute('data-topbar-color', color);
        this.setSwitchFromConfig();
    }

    changeSidebarUser(showUser) {

        this.config.sidenav.user = showUser;
        if (showUser) {
            this.html.setAttribute('data-sidenav-user', showUser);
        } else {
            this.html.removeAttribute('data-sidenav-user');
        }
        this.setSwitchFromConfig();
    }

    resetTheme() {
        this.config = JSON.parse(JSON.stringify(window.defaultConfig));
        this.changeMenuColor(this.config.menu.color);
        this.changeLeftbarSize(this.config.sidenav.size);
        this.changeLayoutColor(this.config.theme);
        this.changeLayoutMode(this.config.layout.mode);
        this.changeLayoutPosition(this.config.layout.position);
        this.changeTopbarColor(this.config.topbar.color);
        this.changeSidebarUser(this.config.sidenav.user);
        this._adjustLayout();
    }

    initSwitchListener() {
        const self = this

        //TopBar Light Dark
        var themeColorToggle = document.getElementById('light-dark-mode');
        if (themeColorToggle) {
            themeColorToggle.addEventListener('click', function () {

                if (self.config.theme === 'light') {
                    self.changeLayoutColor('dark');
                } else {
                    self.changeLayoutColor('light');
                }
            });
        }

        var resetBtn = document.querySelector('#reset-layout')
        if (resetBtn) {
            resetBtn.addEventListener('click', function () {
                self.resetTheme();
            });
        }

        var menuToggleBtn = document.querySelector('.button-toggle-menu');
        if (menuToggleBtn) {
            menuToggleBtn.addEventListener('click', function () {
                var configSize = self.config.sidenav.size;
                var size = self.html.getAttribute('data-sidenav-size', configSize);

                if (size === 'condensed') {
                    self.changeLeftbarSize(configSize == 'condensed' ? 'default' : configSize, false);
                } else {
                    self.changeLeftbarSize('condensed', false);
                }
            });
        }
    }

    initWindowSize() {
        const self = this
        window.addEventListener('resize', function () {
            self._adjustLayout();
        })
    }

    _adjustLayout() {
        const self = this

        if (window.innerWidth <= 767.98) {
            self.changeLeftbarSize('full', false);
        } else if (window.innerWidth >= 767 && window.innerWidth <= 1140) {
            if (self.config.sidenav.size !== 'full' && self.config.sidenav.size !== 'fullscreen') {
                if (self.config.sidenav.size === 'sm-hover') {
                    self.changeLeftbarSize('condensed');
                } else {
                    self.changeLeftbarSize('condensed', false);
                }
            }
        } else {
            self.changeLeftbarSize(self.config.sidenav.size);
            self.changeLayoutMode(self.config.layout.mode);
        }
    }

    setSwitchFromConfig() {

        sessionStorage.setItem('__HYPER_CONFIG__', JSON.stringify(this.config));
        // localStorage.setItem('__HYPER_CONFIG__', JSON.stringify(this.config));

        document.querySelectorAll('.right-bar input[type=checkbox]').forEach(function (checkbox) {
            checkbox.checked = false;
        })

        var config = this.config;
        if (config) {
            var layoutNavSwitch = document.querySelector('input[type=radio][name=data-layout][value=' + config.nav + ']');
            var layoutColorSwitch = document.querySelector('input[type=radio][name=data-bs-theme][value=' + config.theme + ']');
            var layoutModeSwitch = document.querySelector('input[type=radio][name=data-layout-mode][value=' + config.layout.mode + ']');
            var topbarColorSwitch = document.querySelector('input[type=radio][name=data-topbar-color][value=' + config.topbar.color + ']');
            var menuColorSwitch = document.querySelector('input[type=radio][name=data-menu-color][value=' + config.menu.color + ']');
            var leftbarSizeSwitch = document.querySelector('input[type=radio][name=data-sidenav-size][value=' + config.sidenav.size + ']');
            var layoutSizeSwitch = document.querySelector('input[type=radio][name=data-layout-position][value=' + config.layout.position + ']');
            var sidebarUserSwitch = document.querySelector('input[type=checkbox][name=sidebar-user]');

            if (layoutNavSwitch) layoutNavSwitch.checked = true;
            if (layoutColorSwitch) layoutColorSwitch.checked = true;
            if (layoutModeSwitch) layoutModeSwitch.checked = true;
            if (topbarColorSwitch) topbarColorSwitch.checked = true;
            if (menuColorSwitch) menuColorSwitch.checked = true;
            if (leftbarSizeSwitch) leftbarSizeSwitch.checked = true;
            if (layoutSizeSwitch) layoutSizeSwitch.checked = true;
            if (sidebarUserSwitch && config.sidenav.user.toString() === "true") sidebarUserSwitch.checked = true;
        }
    }

    init() {
        initComponents();
        //initSearch();
        initfullScreenListener();
        initShowHidePassword();
        initFormValidation();
        initFormAdvance();

        this.initConfig();
        this.initSwitchListener();
        this.initWindowSize();
        this._adjustLayout();
        this.setSwitchFromConfig();
    }
}
